
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { LeverantorCommandBase } from "./LeverantorCommandBase";

export class UpdateVirkeskopsavtalLeverantorCommand extends LeverantorCommandBase {
    andelTaljare: number;
    andelNamnare: number;
    kontaktperson: boolean;
    overstyrMatbeskedsadress: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateVirkeskopsavtalLeverantorCommand";

    constructor(avtalGuid: string, leverantorGuid: string, andelTaljare?: number, andelNamnare?: number, kontaktperson = false, overstyrMatbeskedsadress = false) {
        super(avtalGuid, leverantorGuid, UpdateVirkeskopsavtalLeverantorCommand.$type, CommandType.Replace);
        this.andelTaljare = andelTaljare;
        this.andelNamnare = andelNamnare;
        this.kontaktperson = kontaktperson;
        this.overstyrMatbeskedsadress = overstyrMatbeskedsadress;
    }
}
